import React from "react";
import "./AboutPage.css";

export default function AboutPage() {
  return <h2 className="about">About</h2>;
}
